import type { MouseEvent } from 'react'

import { setBodyOverflowHidden } from '@/app/_utils/set-body-overflow'

import { HEADER_MENU_NAVIGATE_EVENT } from '../constants'

export const closeMenuOnNavigate = (_e?: MouseEvent, _href?: string, skipHashReplace?: boolean) => {
    setBodyOverflowHidden(false)

    if (typeof window !== 'undefined') {
        if (window.location.hash && !skipHashReplace) {
            const url = window.location.pathname + window.location.search
            window.history.replaceState(null, '', url)
        }
        window.dispatchEvent(new CustomEvent(HEADER_MENU_NAVIGATE_EVENT))
    }

    const headerCheckboxes = document.querySelectorAll(
        'header [type="checkbox"]:checked'
    ) as NodeListOf<HTMLInputElement>

    if (headerCheckboxes) {
        setTimeout(() => {
            headerCheckboxes.forEach((item) => (item.checked = false))
        }, 1000)
    }
}
